import { isCaseOpen } from '.';

export default function caseStatus(serviceCase) {
  return isCaseOpen(serviceCase) ? 'open' : 'closed';
}
